// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1RzUp","approved":"Status_approved__1-c5S","rejected":"Status_rejected__1KI60","expired":"Status_expired__2zKKB","label":"Status_label__3pSYf"};